import moment from 'moment-timezone';
import { CREATORS_PAGE_COUNT, MAX_RANGE, MIN_RANGE, SESSION_PAGE_COUNT } from '../../Utils/Constants';
export const GET_ADMIN_SESSIONS_REQUEST = 'GET_ADMIN_SESSIONS_REQUEST';
export const GET_ADMIN_SESSIONS_SUCCESS = 'GET_ADMIN_SESSIONS_SUCCESS';
export const GET_ADMIN_SESSIONS_FAILURE = 'GET_ADMIN_SESSIONS_FAILURE';
export const GET_ADMIN_SESSIONS_TRENDS_REQUEST = 'GET_SESSIONS_TRENDS_REQUEST';
export const GET_ADMIN_SESSIONS_TRENDS_SUCCESS = 'GET_SESSIONS_TRENDS_SUCCESS';
export const GET_ADMIN_SESSIONS_TRENDS_FAILURE = 'GET_SESSIONS_TRENDS_FAILURE';
export const TOGGLE_ADMIN_SESSION = 'TOGGLE_ADMIN_SESSION';
export const TOGGLE_ALL_ADMIN_SESSIONS = 'TOGGLE_ALL_ADMIN_SESSIONS';
export const POST_UNIQUE_ADMIN_TABLE_ID = 'POST_UNIQUE_ADMIN_TABLE_ID';
export const GET_SESSION_CREATORS_REQUEST = 'GET_SESSION_CREATORS_REQUEST';
export const GET_SESSION_CREATORS_SUCCESS = 'GET_SESSION_CREATORS_SUCCESS';
export const GET_SESSION_CREATORS_FAILURE = 'GET_SESSION_CREATORS_FAILURE';
export const RESET_SESSION_CREATORS_REQUEST = 'RESET_SESSION_CREATORS_REQUEST';

export function getAdminLastTenSessions(accountKey) {
  return getAdminSessions(
    accountKey,
    moment()
      .subtract(1, 'year')
      .toISOString(),
    moment().toISOString(),
    [],
    [MIN_RANGE, MAX_RANGE],
    [MIN_RANGE, MAX_RANGE],
    '',
    0,
    10,
    true
  );
}

export function getAdminSessions(
  accountKey,
  fromTime = moment()
    .subtract(2, 'year')
    .toISOString(),
  toTime = moment().toISOString(),
  creators = [],
  registrantRange = [MIN_RANGE, MAX_RANGE],
  attendeeRange = [MIN_RANGE, MAX_RANGE],
  filter = '',
  page = 0,
  limit = SESSION_PAGE_COUNT,
  loadPage = true
) {
  return {
    type: GET_ADMIN_SESSIONS_REQUEST,
    payload: { fromTime, toTime, page, limit, accountKey, creators, filter, registrantRange, attendeeRange, loadPage }
  };
}

export function toggleAdminSession(sessionKey, isSelected, uniqueTableId) {
  return {
    type: TOGGLE_ADMIN_SESSION,
    payload: { sessionKey, isSelected, uniqueTableId }
  };
}

export function toggleAllAdminSessions(isSelected = true, uniqueTableId) {
  return {
    type: TOGGLE_ALL_ADMIN_SESSIONS,
    payload: { isSelected, uniqueTableId }
  };
}

export function postAdminTableId(uniqueTableId) {
  return {
    type: POST_UNIQUE_ADMIN_TABLE_ID,
    payload: { uniqueTableId }
  };
}

export function getSessionCreators(
  accountKey,
  fromTime = moment()
    .subtract(1, 'year')
    .toISOString(),
  toTime = moment().toISOString(),
  page = 0,
  filter,
  limit = CREATORS_PAGE_COUNT,
  loadCreators = false
) {
  return {
    type: GET_SESSION_CREATORS_REQUEST,
    payload: { accountKey, fromTime, toTime, page, filter, limit, loadCreators }
  };
}

export function resetSessionCreators() {
  return {
    type: RESET_SESSION_CREATORS_REQUEST
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/AdminSessions/AdminSessionsActions.js